import { useEffect, useRef } from 'react';

interface PolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
}

export default function PolicyModal({ isOpen, onClose, title, content }: PolicyModalProps) {
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
    }
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === overlayRef.current) {
      onClose();
    }
  };

  return (
    <div
      ref={overlayRef}
      onClick={handleOverlayClick}
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)'
      }}
    >
      <div
        className="relative bg-white rounded-2xl shadow-2xl flex flex-col"
        style={{
          width: '90vw',
          maxWidth: '800px',
          maxHeight: '85vh',
          animation: 'modalFadeIn 0.3s ease-out'
        }}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between px-6 py-4 border-b border-gray-200"
          style={{ flexShrink: 0 }}
        >
          <h2
            style={{
              fontSize: '1.25rem',
              fontFamily: "'Prompt-Medium', 'Prompt', sans-serif",
              fontWeight: 500,
              color: '#000000'
            }}
          >
            {title}
          </h2>
          <button
            onClick={onClose}
            className="flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors duration-200"
            style={{
              width: '36px',
              height: '36px',
              fontSize: '1.5rem',
              lineHeight: 1,
              color: '#000000'
            }}
            aria-label="Fechar"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div
          className="flex-1 overflow-y-auto px-6 py-5"
          style={{
            minHeight: 0
          }}
        >
          <div
            className="policy-content"
            style={{
              fontFamily: "'Prompt-Light', 'Prompt', sans-serif",
              color: '#000000',
              fontSize: '15px',
              lineHeight: '1.8',
              textAlign: 'justify',
              fontWeight: 300,
              letterSpacing: '0.01em'
            }}
            dangerouslySetInnerHTML={{ __html: content || '<p style="color: #999; text-align: center;">Conteúdo não disponível.</p>' }}
          />
        </div>

        {/* Footer */}
        <div
          className="flex justify-end px-6 py-4 border-t border-gray-200"
          style={{ flexShrink: 0 }}
        >
          <button
            onClick={onClose}
            className="text-white rounded-lg hover:opacity-90 transition-opacity duration-200"
            style={{
              backgroundColor: '#8B4513',
              padding: '10px 32px',
              fontSize: '0.9rem',
              fontFamily: "'Prompt-Medium', 'Prompt', sans-serif",
              fontWeight: 500,
              letterSpacing: '0.02em'
            }}
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}
